var i = Object.defineProperty;
var l = (c, e, t) => e in c ? i(c, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : c[e] = t;
var r = (c, e, t) => l(c, typeof e != "symbol" ? e + "" : e, t);
const a = "$tenants";
class u {
  constructor(e) {
    r(this, "instance");
    this.instance = e;
  }
  async authCheck({ tenant: e, knockChannelId: t }) {
    const s = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/providers/slack/${t}/auth_check`,
      params: {
        access_token_object: {
          object_id: e,
          collection: a
        },
        channel_id: t
      }
    });
    return this.handleResponse(s);
  }
  async getChannels(e) {
    const { knockChannelId: t, tenant: s } = e, n = e.queryOptions || {}, o = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/providers/slack/${t}/channels`,
      params: {
        access_token_object: {
          object_id: s,
          collection: a
        },
        channel_id: t,
        query_options: {
          cursor: n.cursor,
          limit: n.limit,
          exclude_archived: n.excludeArchived,
          team_id: n.teamId,
          types: n.types
        }
      }
    });
    return this.handleResponse(o);
  }
  async revokeAccessToken({ tenant: e, knockChannelId: t }) {
    const s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/providers/slack/${t}/revoke_access`,
      params: {
        access_token_object: {
          object_id: e,
          collection: a
        },
        channel_id: t
      }
    });
    return this.handleResponse(s);
  }
  handleResponse(e) {
    var t, s;
    if (e.statusCode === "error") {
      if (((s = (t = e.error) == null ? void 0 : t.response) == null ? void 0 : s.status) < 500)
        return e.error || e.body;
      throw new Error(e.error || e.body);
    }
    return e.body;
  }
}
export {
  u as default
};
//# sourceMappingURL=index.mjs.map
